const getters = {
  swatchesPath(state) {
    return (type = 'customizer') => `${state[type].s3SwatchesBucket}assets`;
  }
};

export default getters;
